import { Resource } from '@ngxp/rest';
import { ListResource } from '@schir-int-client/ngrx-helpers';
import { UnterscheidungssignalListLinkRel } from './admin.linkrel';

export interface AdminRoot {}

export interface AdminRootResource extends AdminRoot, Resource {}

export interface Unterscheidungssignal {
	signal: string;
	verfahrenId: number;
	lastChanged: Date;
	aktenzeichen: string;
	status: USIGNAL_STATUS;
}

export interface UnterscheidungssignalResource extends Unterscheidungssignal, Resource {}

export interface UnterscheidungssignalListResource extends ListResource<
	UnterscheidungssignalResource,
	UnterscheidungssignalListLinkRel.UNTERSCHEIDUNGSSIGNALE
> {}

export enum USIGNAL_STATUS {
	FREI = 'FREI',
	BLOCKIERT = 'BLOCKIERT',
	VERGEBEN = 'VERGEBEN',
}

export enum ErrorType {
	UNPROCESSABLE_ENTITY,
}

export interface EntityError {
	type: ErrorType;
}

export class UnprocessableEntityError implements EntityError {
	error: {
		issues: { field: string; message: string }[];
	};
	type: ErrorType = ErrorType.UNPROCESSABLE_ENTITY;
}
